import { api } from '@/resources/utils/api';

import Employers from '@/resources/constants/employers';
import Employer from '@/resources/models/employers';

import Employees from '@/resources/constants/employees';
import Policies from '@/resources/constants/policies';
import ReportsOfSickness from '@/resources/constants/reports-of-sickness';
import ProcessDates from '@/resources/constants/process-dates';

import App from '@/views/constants/app';

const state = {
  employers: [],
  employersIsLoading: false,

  selectedEmployer: null
};

const getters = {
  employers: state => state.employers,
  employersIsLoading: state => state.employersIsLoading,

  selectedEmployer: state => state.selectedEmployer
};

const actions = {
  [Employers.Actions.LoadAll.START] ({ commit, dispatch }) {
    commit(Employers.Mutations.IsLoading.SET, true);

    api.get(encodeURI(Employers.Endpoints.LoadAll()))
      .then((response) => {
        dispatch(Employers.Actions.LoadAll.SUCCESS, response.data);
        // commit(Employers.Mutations.SELECT, new Employer(response.data[0]));
      })
      .finally(() => {
        commit(Employers.Mutations.IsLoading.SET, false);
      });
  },

  [Employers.Actions.LoadAll.SUCCESS] ({ commit, dispatch, getters }, data) {
    commit(Employers.Mutations.SET, data);

    const storedEmployer = localStorage.getItem('employer');
    if (storedEmployer != null) {
      const employer = getters.employers.find(e => e.id.toString() === storedEmployer.toString());
      if (employer != null) {
        dispatch(Employers.Actions.SELECT, employer);
        return;
      }
    }

    dispatch(Employers.Actions.SELECT, getters.employers[0]);
  },

  [Employers.Actions.SELECT] ({ commit, dispatch }, employer) {
    commit(Employers.Mutations.SELECT, employer);
    dispatch(App.Actions.CLEAR)
      .then(() => {
        dispatch(Employees.Actions.LoadAll.START, employer.id);
        dispatch(Policies.Actions.LoadAll.START, employer.id);
        dispatch(ReportsOfSickness.Actions.LoadAll.START, employer.id);
        dispatch(ProcessDates.Actions.IsProcessing.START);
      });
  }
};

const mutations = {
  [Employers.Mutations.IsLoading.SET] (state, payload) {
    state.employersIsLoading = payload;
  },

  [Employers.Mutations.SET] (state, payload) {
    state.employers = payload.map((e, i) => {
      if (e != null) {
        let employer = new Employer(e);
        return employer;
      }
    });
  },

  [Employers.Mutations.SELECT] (state, payload) {
    state.selectedEmployer = payload;
  }
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
